module.exports = __webpack_public_path__ + "static/img/组 2860.31256c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2860.png
// module id = LKPs
// module chunks = 0